import React from "react";
import { Link, useHistory, useLocation } from "react-router-dom";
import Footer from "../../../Layouts/Footer";
import ProfileInfo from "../../../Layouts/ProfileInfo";
const Sidebar = () => {
  //assigning location variable
  const location = useLocation();
  const { pathname } = location;
  const url = pathname.split("/jury-board/");

  return (
    <nav className="sb-sidenav accordion sb-sidenav-dark" id="sidenavAccordion">
      <div className="sb-sidenav-menu">
        <div className="nav">
          <ProfileInfo />
          <div className="sb-sidenav-menu-heading">Core</div>

          <Link
            className={
              url[1] === "dashboard" ? "nav-link active-nav" : "nav-link"
            }
            to="/jury-board/dashboard"
          >
            <span className="">
              <i className="fas fa-tachometer-alt"></i> &nbsp; Dashboard
            </span>
          </Link>

          <Link
            className={
              url[1] === "live-audition" ? "nav-link active-nav" : "nav-link"
            }
            to="/jury-board/live-audition"
          >
            <span className="">
              <i class="fa-solid fa-satellite-dish"></i> &nbsp; Live Audition
            </span>
          </Link>

          <Link
            className={
              url[1] === "profile-settings" ? "nav-link active-nav" : "nav-link"
            }
            to="/jury-board/profile-settings"
          >
            <span className="">
              <i class="fa-solid fa-gear"></i> &nbsp; Settings
            </span>
          </Link>
        </div>
      </div>
      <Footer />
    </nav>
  );
};

export default Sidebar;
